import axios from 'axios';

// Portal reuses the DevOps Center backend for auth via a same-origin /api proxy.
// - Local dev: package.json "proxy" forwards /api -> DevOps backend
// - Production: nginx proxies /api -> http://localhost:9090 (same server as DevOps)
// Same-origin in both cases => no CORS needed.
const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
